import React from 'react'

import DatePickerPreset from './DatePickerPreset'
import styles from './styles.less'

const PRESETS = {
  this_1_day: 'Today',
  previous_1_day: 'Yesterday',
  previous_7_days: 'Last 7 days',
  previous_4_weeks: 'Last 4 weeks',
  this_1_month: 'This month',
  previous_1_month: 'Last month',
  all_time: 'All time',
}

export default function DatePickerPresets({ onApply }) {
  return (
    <div className={styles.DatePickerPresets}>
      <span>Ranges:</span>
      {Object.keys(PRESETS).map(key => {
        const preset = PRESETS[key]
        return preset ? (
          <DatePickerPreset
            key={key}
            onApply={onApply}
            text={preset}
            timeframe={key}
          />
        ) : null
      })}
    </div>
  )
}
